import type { MessageApi } from './types';
import { createContext } from 'react';

export const MessageContext = createContext<MessageApi | null>(null);
